export function createCoverOverlay(container: HTMLElement) {
  const cover = document.createElement("div");
  cover.className = "cover-overlay";

  container.style.position = "relative";

  cover.innerHTML = `
<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" width="40" height="40" rx="20" fill="#F2F2F333" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0115 8.54959C13.534 8.25374 14.1753 8.26183 14.6902 8.57076L31.3568 18.5708C31.8588 18.872 32.166 19.4145 32.166 19.9999C32.166 20.5854 31.8588 21.1279 31.3568 21.4291L14.6902 31.4291C14.1753 31.738 13.534 31.7461 13.0115 31.4503C12.489 31.1544 12.166 30.6004 12.166 29.9999L12.166 9.99992C12.166 9.39947 12.489 8.84543 13.0115 8.54959ZM15.4993 12.9436L15.4993 27.0563L27.2599 19.9999L15.4993 12.9436Z" fill="white" fill-opacity="0.8" />
</svg>
  `;

  container.appendChild(cover);
}
